import React from 'react';
import { IMatrixMessage } from '../../../client/message/types';

interface RoomEncryptionMessageProps {
  message: IMatrixMessage;
  className?: string;
}

export const RoomEncryptionMessage = ({ message, className = '' }: RoomEncryptionMessageProps) => {
  return (
    <div className={`room-encryption-message ${className}`} style={{ color: '#388e3c', padding: '8px 0' }}>
      已启用端到端加密
    </div>
  );
}; 